import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-550ae257"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex flex-column p-1 gap-5" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_6 = { class: "lista_atendimentos card p-0" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<li class=\"header_list d-flex col-12 p-6\" data-v-550ae257><span class=\"col-3 d-flex justify-content-start subtitulo\" data-v-550ae257>Código do produto</span><span class=\"col-3 d-flex justify-content-start subtitulo\" data-v-550ae257>Descrição</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-550ae257>Código do fabricante</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-550ae257>Código grupo</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-550ae257>Ação</span></li>", 1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col-3 d-flex justify-content-start" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "col-3 d-flex justify-content-start" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "col-2 d-flex justify-content-center ps-2" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_19 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Nenhum produto encontrado . . .", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "card p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ModalProdutoIpiranga = _resolveComponent("ModalProdutoIpiranga")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Produtos Ipiranga")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          onKeyup: _ctx.buscar,
          clearable: "",
          placeholder: "Digite...",
          modelValue: _ctx.fastFind,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fastFind) = $event))
        }, null, 8, ["onKeyup", "modelValue"]),
        _createVNode(_component_Button, {
          text: "Voltar",
          type: "button",
          onClick: _cache[1] || (_cache[1] = () => _ctx.router.back())
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          text: "Adicionar Produto",
          style: {"min-width":"fit-content"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (!_ctx.loadProdutos)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.totalProdutos)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosArray, (produto, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      style: {"height":"fit-content","border-radius":"10px"},
                      class: "usuario card d-flex flex-row col-12 p-5 align-items-center"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", {
                          style: {"white-space":"nowrap"},
                          class: "texto bold cor_texto_1 d-inline-block text-truncate",
                          title: produto?.codigoProduto
                        }, _toDisplayString(produto?.codigoProduto || "-"), 9, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", {
                          style: {"white-space":"nowrap"},
                          class: "texto cor_texto_1 d-inline-block text-truncate",
                          title: produto?.descricaoLongaProduto
                        }, _toDisplayString(produto?.descricaoLongaProduto || "-"), 9, _hoisted_12)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", {
                          style: {"white-space":"nowrap"},
                          class: "texto bold cor_texto_1 d-inline-block text-truncate",
                          title: produto?.codigoFabricante
                        }, _toDisplayString(produto?.codigoFabricante || "-"), 9, _hoisted_14)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", {
                          style: {"white-space":"nowrap"},
                          class: "texto cor_texto_1 d-inline-block text-truncate",
                          title: produto?.codigoGrupo
                        }, _toDisplayString(produto?.codigoGrupo || "-"), 9, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Button, {
                          variant: "primary",
                          text: "Editar",
                          onClick: ($event: any) => (_ctx.openModal(produto))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              rows: 10
            })
          ]))
    ]),
    (_openBlock(), _createBlock(_component_Pagination, {
      key: _ctx.route.path,
      arr: _ctx.produtosArray,
      totalBanco: _ctx.totalProdutos,
      onPageChanged: _ctx.handlePageChange,
      tipo: 'produtos'
    }, null, 8, ["arr", "totalBanco", "onPageChanged"])),
    _createVNode(_component_ModalProdutoIpiranga, {
      fechaModal: _ctx.fechaModal,
      data: _ctx.produtoModal
    }, null, 8, ["fechaModal", "data"])
  ]))
}